var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Domain Change Instructions ")]),
      _c("gg-card-text", [
        _c("p", [
          _vm._v(
            " Before the Primary Domain on your hosting account can be updated, the following requirements must be met: "
          )
        ]),
        _c("p", [
          _c("ul", [
            _c("li", [
              _c("strong", [_vm._v("Domain Availability:")]),
              _vm._v(
                " The new domain must not exist on the GreenGeeks network. If you've already added the new domain please remove it before proceeding."
              )
            ]),
            _c("li", [
              _c("strong", [_vm._v("Domain Verification:")]),
              _vm._v(
                " The new domain must point to GreenGeeks' nameservers, or be verified via a TXT record at your DNS provider."
              )
            ])
          ])
        ]),
        _c("p", [
          _vm._v(
            " As part of the process, your hosting account's Primary Domain will be updated to the new domain name, along with any Email or FTP accounts. "
          )
        ]),
        _c("p", [
          _vm._v(
            "If you have an existing WordPress website, the Website and Home URLs will be automatically updated to the new domain along with the SSL certificate. Note that reissuing the new SSL Certificate takes a few minutes and you'll see SSL warning messages until this process finishes."
          )
        ]),
        _c("p", [
          _c("strong", [_vm._v("To verify a new domain via TXT record:")])
        ]),
        _c("p", [
          _c("ol", [
            _c("li", [
              _vm._v("Access your existing DNS provider for the new domain.")
            ]),
            _c("li", [
              _vm._v("Add this TXT record under the root domain (@): "),
              _c("strong", [
                _c("i", [_vm._v("greengeeks-domain-ownership-verification")])
              ])
            ]),
            _c("li", [
              _vm._v(
                "Allow some time for DNS propagation (usually 1-2 hours), then submit your request."
              )
            ])
          ])
        ]),
        _c("p", [
          _c(
            "strong",
            [
              _vm._v("Need help? "),
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "support_ticketnew",
                      query: {
                        d: "Support",
                        s: _vm.hosting.id,
                        sbj: "Domain Change Assistance"
                      }
                    }
                  }
                },
                [_vm._v("Contact GreenGeeks Support.")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }